import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import {
  Config
} from "@/shared/config";
const prodEnv = require("./prod.env");
import store from "./../store"
import _ from "lodash";
import {
  LOGOUT
} from "@/store/actions.type";
// window.axios = require("axios");
// window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// import errorResponseHandler from "@/services/errorHandler";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = Config.apiUrl;
  },

  setHeader() {
    let token = localStorage.getItem("token");
    // Vue.axios.defaults.headers.common[
    //     "Authorization"
    // ] = `Token ${token}`;
    axios.defaults.headers.common.Authorization = "Bearer " + token;
  },
  async post(resource, params) {
    ApiService.setHeader();
    let data = await axios.post(Config.apiUrl + `${resource}`, params).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        console.log(error.response.status);
        if (error.response.status == 401) {
          store
            .dispatch(LOGOUT);
          window.location.href = "/";

        }
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return {
          data: {
            status: false,
            message: "処理に失敗しました！"
          }
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      store
        .dispatch(LOGOUT);
      window.location.href = "/";
    }
    return data;
  },
  async get(resource, params) {
    ApiService.setHeader();
    let data = await axios.get(Config.apiUrl + `${resource}`, {
      params: params
    }).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        console.log(error.response.status);
        if (error.response.status == 401) {
          store
            .dispatch(LOGOUT);
          window.location.href = "/";

        }
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return {
          data: {
            status: false,
            message: "処理に失敗しました！"
          }
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      store
        .dispatch(LOGOUT);
      window.location.href = "/";
    }
    return data;
  },
  async put(resource, params) {
    ApiService.setHeader();
    let data = await axios.put(Config.apiUrl + `${resource}`, params).catch(function (error) {
      if (error.mresponse) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        console.log(error.response.status);
        if (error.response.status == 401) {
          store
            .dispatch(LOGOUT);
          window.location.href = "/";

        }
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return {
          data: {
            status: false,
            message: "処理に失敗しました！"
          }
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      store
        .dispatch(LOGOUT);
      window.location.href = "/";
    }
    return data;
  },
  async delete(resource, params) {
    ApiService.setHeader();
    let data = await axios.delete(Config.apiUrl + `${resource}`, params).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        console.log(error.response.status);
        if (error.response.status == 401) {
          store
            .dispatch(LOGOUT);
          window.location.href = "/";

        }
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return {
          data: {
            status: false,
            message: "処理に失敗しました！"
          }
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      store
        .dispatch(LOGOUT);
      window.location.href = "/";
    }
    return data;
  },
  async patch(resource, params) {
    ApiService.setHeader();
    let data = await axios.patch(Config.apiUrl + `${resource}`, params).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        console.log(error.response.status);
        if (error.response.status == 401) {
          store
            .dispatch(LOGOUT);
          window.location.href = "/";

        }
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return {
          data: {
            status: false,
            message: "処理に失敗しました！"
          }
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      store
        .dispatch(LOGOUT);
      window.location.href = "/";
    }
    return data;
  },
  async fileUpload(resource, params) {
    ApiService.setHeader();
    let data = await axios.post(Config.apiUrl + `${resource}`, params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        console.log(error.response.status);
        if (error.response.status == 401) {
          store
            .dispatch(LOGOUT);
          window.location.href = "/";

        }
        // console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        return {
          data: {
            status: false,
            message: "処理に失敗しました！"
          }
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      store
        .dispatch(LOGOUT);
      window.location.href = "/";
    }
    return data;
  }
};

export default ApiService;